import React from 'react';
import { CFormInput, CButton, CFormSelect } from '@coreui/react';

const BuscadorSenales = React.memo(function BuscadorSenales({
  searchInput,
  setSearchInput,
  buscarTexto,
  setBuscarTexto,
  claseSeleccionada,
  setClaseSeleccionada,
  fetchData2,
  setCurrentPageSenales,
  currentPageFisuras,
  lines,
  Tooltip,
  isLoading
}) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <CFormInput
        size="sm"
        placeholder="Buscar por id_frame"
        style={{ width: '30%' }}
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
        disabled={isLoading}
      />
      <CButton size="sm" className="btn-color" disabled={isLoading}
        onClick={() => {
          const term = searchInput.trim();
          setBuscarTexto && setBuscarTexto(term);
          setCurrentPageSenales(1);
          fetchData2(1, currentPageFisuras, 0, claseSeleccionada, term);
        }}
        title="Buscar por id_frame"
      >
        {isLoading ? 'Buscando...' : 'Buscar'}
      </CButton>
      <CButton size="sm" className="btn-color-secundario" disabled={isLoading}
        onClick={() => {
          setSearchInput('');
          setBuscarTexto && setBuscarTexto('');
          setCurrentPageSenales(1);
          fetchData2(1, currentPageFisuras, 0, claseSeleccionada, '');
        }}
        title="Limpiar búsqueda"
      >
        Limpiar
      </CButton>
      <CFormSelect
        size="sm"
        style={{ width: '20%', marginLeft: '10px' }}
        value={claseSeleccionada}
        disabled={isLoading}
        onChange={(e) => {
          setClaseSeleccionada(e.target.value);
          setCurrentPageSenales(1);
          fetchData2(1, currentPageFisuras, 0, e.target.value, buscarTexto);
        }}
      >
        <option value="">Todas las clases</option>
        <option value="arbol">Árbol</option>
        <option value="alumbrado">Alumbrado</option>
        <option value="semaforo">Semáforo</option>
        <option value="basura">Basura</option>
        <option value="bache">Bache</option>
      </CFormSelect>
      <div className="">
        <Tooltip text={
          <div><span style={{ lineHeight: '0.3' }}>
            {lines.map((line, index) => <p key={index}>{line}</p>)}</span>
          </div>
        }>
          <span className="d-inline-block padding-tooltip" tabIndex={0}>
            <CButton className="btn-round-small-find">?</CButton>
          </span>
        </Tooltip>
      </div>
    </div>
  );
});

export default BuscadorSenales;
